/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import * as axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import type { AddUsersToRoleDto } from "../types/addUsersToRoleDto";

import type { GetRolesParams } from "../types/getRolesParams";

import type { ProblemDetails } from "../types/problemDetails";

import type { RoleDto } from "../types/roleDto";

import type { RoleListItemDto } from "../types/roleListItemDto";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

export const getRoles = (
  params?: GetRolesParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<RoleListItemDto[]>> => {
  return axios.default.get(`/api/roles`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getGetRolesQueryKey = (params?: GetRolesParams) => {
  return [`/api/roles`, ...(params ? [params] : [])] as const;
};

export const getGetRolesQueryOptions = <
  TData = Awaited<ReturnType<typeof getRoles>>,
  TError = AxiosError<unknown>,
>(
  params?: GetRolesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getRoles>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetRolesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRoles>>> = ({
    signal,
  }) => getRoles(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRoles>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetRolesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRoles>>
>;
export type GetRolesQueryError = AxiosError<unknown>;

export function useGetRoles<
  TData = Awaited<ReturnType<typeof getRoles>>,
  TError = AxiosError<unknown>,
>(
  params?: GetRolesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getRoles>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetRolesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getRoleById = (
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<RoleDto>> => {
  return axios.default.get(`/api/roles/${id}`, options);
};

export const getGetRoleByIdQueryKey = (id?: string) => {
  return [`/api/roles/${id}`] as const;
};

export const getGetRoleByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getRoleById>>,
  TError = AxiosError<ProblemDetails>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getRoleById>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetRoleByIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRoleById>>> = ({
    signal,
  }) => getRoleById(id, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getRoleById>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetRoleByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRoleById>>
>;
export type GetRoleByIdQueryError = AxiosError<ProblemDetails>;

export function useGetRoleById<
  TData = Awaited<ReturnType<typeof getRoleById>>,
  TError = AxiosError<ProblemDetails>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getRoleById>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetRoleByIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const addUsersToRole = (
  id: string,
  addUsersToRoleDto: AddUsersToRoleDto,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<void>> => {
  return axios.default.post(
    `/api/roles/${id}/users`,
    addUsersToRoleDto,
    options,
  );
};

export const getAddUsersToRoleMutationOptions = <
  TError = AxiosError<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addUsersToRole>>,
    TError,
    { id: string; data: AddUsersToRoleDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addUsersToRole>>,
  TError,
  { id: string; data: AddUsersToRoleDto },
  TContext
> => {
  const mutationKey = ["addUsersToRole"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addUsersToRole>>,
    { id: string; data: AddUsersToRoleDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return addUsersToRole(id, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddUsersToRoleMutationResult = NonNullable<
  Awaited<ReturnType<typeof addUsersToRole>>
>;
export type AddUsersToRoleMutationBody = AddUsersToRoleDto;
export type AddUsersToRoleMutationError = AxiosError<ProblemDetails>;

export const useAddUsersToRole = <
  TError = AxiosError<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addUsersToRole>>,
    TError,
    { id: string; data: AddUsersToRoleDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof addUsersToRole>>,
  TError,
  { id: string; data: AddUsersToRoleDto },
  TContext
> => {
  const mutationOptions = getAddUsersToRoleMutationOptions(options);

  return useMutation(mutationOptions);
};
